import React, { useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const useDialog = () => {
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
    onConfirm: null,
  });

  const showDialog = useCallback(({ title, content, onConfirm }) => {
    setDialogContent({ title, content, onConfirm });
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    if (dialogContent.onConfirm) {
      dialogContent.onConfirm();
    }
    setOpen(false);
  }, [dialogContent]);

  const DialogComponent = (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{dialogContent.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogContent.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { showDialog, DialogComponent };
};
export default useDialog;